import { useAuthUserQuery, useSubscriptionStatusQuery } from "@/hooks";
import TrialFormatPriceSVOD from "./TrialFormatPriceSVOD";
import NonTrialFormatPriceSVOD from "./NonTrialFormatPriceSVOD";
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormatPriceSVOD(_ref) {
  var _data$subscriptionSta;
  let {
    price,
    ext,
    course
  } = _ref;
  const {
    data,
    loading: loadingSubscriptionStatus
  } = useSubscriptionStatusQuery({
    variables: {
      courseId: Number(course === null || course === void 0 ? void 0 : course.id)
    }
  });
  const {
    data: user,
    loading: loadingUser
  } = useAuthUserQuery();
  if (loadingUser && loadingSubscriptionStatus) return null;
  const loggedIn = !loadingUser && (user === null || user === void 0 ? void 0 : user.user);
  const isTrialEnabled = loggedIn ? data === null || data === void 0 || (_data$subscriptionSta = data.subscriptionStatus) === null || _data$subscriptionSta === void 0 ? void 0 : _data$subscriptionSta.is_trial_enabled : true;
  if (course !== null && course !== void 0 && course.trial_flag && isTrialEnabled) {
    return /*#__PURE__*/_jsx(TrialFormatPriceSVOD, {
      price: price,
      ext: ext,
      course: course
    });
  } else {
    return /*#__PURE__*/_jsx(NonTrialFormatPriceSVOD, {
      price: price,
      ext: ext
    });
  }
}